import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { CardListProps } from "./types";
import { EntryOptions, PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { MetaTypeEnum } from "app/shared";

import { CardPropertyDefinitions, ColumnSettingsDefinition } from 'components/cms/definitions';

export class CardListDefinitions extends CmsReactComponent<CardListProps> {
    static schemaName = "card-list";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "cards",
            description: "Kart List Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: CardPropertyDefinitions,
            },
            group: {
                key: "data",
                title: "Kart Verileri",
                withObject: false,
            }
        },
        {
            name: "appearance",
            mapping: {
                type: PropertyMappingType.Object,
                oneOf: [
                    {
                        key: '',
                        text: 'Varsayılan'
                    },
                    {
                        key: 'bordered',
                        text: 'Kenarlıklı'
                    },
                    {
                        key: 'rounded',
                        text: 'Yuvarlak'
                    },
                    {
                        key: 'center',
                        text: 'Ortala'
                    },
                    {
                        key: 'social-media',
                        text: 'Sosyal Medya Görünümü'
                    },
                    {
                        key: 'digital-scene',
                        text: 'Dijital Perde Görünümü'
                    },
                    {
                        key: 'video',
                        text: 'Video Görünümü'
                    }
                ]
            },
            description: "Görünüm Tipleri",
        },
        {
            name: "width",
            text: "Genişlik",
            description: "Kart Görsel Genişliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "height",
            text: "Yükseklik",
            description: "Kart Görsel Yüksekliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "anchorText",
            text: "Link metini",
            description: "İçeriğin yönlendirilmesi için kullanılacak metin",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "isMoreButton",
            text: "Buton gözüksün mü",
            description: "İçeriğin yönlendirilmesi için kullanılacak metin",
            mapping: {
                type: PropertyMappingType.Boolean
            }
        },
        ...ColumnSettingsDefinition
    ];

    static options: EntryOptions = {
        meta: {
            use: false,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "id",
                text: "Card ID",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "title",
                text: "Card Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Dropdown],
            },
            {
                name: "description",
                text: "Card Açıklaması",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Editor],
            },
            {
                name: "image",
                text: "Card Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "subtitle",
                text: "Card Alt Başlığı",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Dropdown],
            },
            {
                name: "datetime",
                text: "Card Zaman Bilgisi",
                types: [MetaTypeEnum.Date, MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "anchor",
                text: "Card URL",
                types: [MetaTypeEnum.Link]
            },
        ],
    };
}
